import { FC, useMemo } from 'react'
import { FEED_OWN_POST_COMPOSE_ID } from 'constants/feed'
import { CardBlock } from 'components/features/pfm/Blocks/Blocks'
import { ComposeExpanded } from 'components/features/socialFeed/ComposeExpanded/ComposeExpanded'
import { MemberAvatar } from 'components/features/socialFeed/Avatar/MemberAvatar'
import styles from 'components/features/pfm/PostCompose/PostCompose.styl'
import { ComposeFocusable } from 'components/features/socialFeed/ComposeFocusable/ComposeFocusable'
import { ComposeAttach } from 'components/features/socialFeed/ComposeAttach/ComposeAttach'
import { ComposeInputController } from 'components/features/socialFeed/ComposeInputController/ComposeInputController'
import { ComposeActions } from 'components/features/socialFeed/ComposeActions/ComposeActions'
import { ComposeMount } from 'components/features/socialFeed/ComposeMount/ComposeMount'
import { PostScope } from 'components/features/pfm/PostScope/PostScope'
import Button from 'components/features/pfm/Button/Button'
import { ComposeNextToInput } from 'components/features/socialFeed/ComposeNextToInput/ComposeNextToInput'
import { IS_IOS_LT_13 } from 'helpers/userAgentHelpers'
import cn from 'classnames'
import { SocialProfileEnsure } from 'components/features/socialFeed/SocialProfileEnsure/SocialProfileEnsure'
import { useComposeState } from 'helpers/hookHelpers'

export const PostCompose: FC = () => {
  const composeId = FEED_OWN_POST_COMPOSE_ID
  const { id } = useComposeState(composeId, { id: null })
  const withComposeId = useMemo(() => ({ composeId: FEED_OWN_POST_COMPOSE_ID }), [])

  const isCreated = id !== null

  const placeholderClassName = useMemo(() => cn(
    styles.inputPlaceholder,
    {
      // Fix for iOS textarea 3px padding issue
      // For more information see https://stackoverflow.com/questions/6890149/remove-3-pixels-in-ios-webkit-textarea
      [styles.safariIos]: IS_IOS_LT_13,
    }
  ), [])

  return (
    <SocialProfileEnsure { ...withComposeId }>
      <ComposeMount
        persistent
        placeholder='Start typing'
        { ...withComposeId }
      >
        { isCreated && (
          <ComposeFocusable { ...withComposeId }>
            <CardBlock forceRoundedCorners withPadding shadowTheme='medium' className={ styles.container } corners='all'>
              <ComposeExpanded { ...withComposeId }>
                <div className={ styles.scopeSelector }>
                  <PostScope { ...withComposeId } />
                </div>
              </ComposeExpanded>
              <div className={ styles.middle }>
                <div className={ styles.avatar }>
                  <MemberAvatar />
                </div>
                <div className={ styles.content }>
                  <div className={ styles.input }>
                    <ComposeInputController { ...withComposeId } />
                    <ComposeExpanded inverse { ...withComposeId }>
                      <div className={ placeholderClassName }>
                        <Button size='small'>Create a post</Button>
                      </div>
                    </ComposeExpanded>
                  </div>
                  <ComposeExpanded { ...withComposeId }>
                    <ComposeNextToInput { ...withComposeId } />
                  </ComposeExpanded>
                  <div className={ styles.attach }>
                    <ComposeAttach { ...withComposeId } />
                  </div>
                </div>
              </div>
              <ComposeExpanded { ...withComposeId }>
                <div className={ styles.actions }>
                  <ComposeActions
                    { ...withComposeId }
                  />
                </div>
              </ComposeExpanded>
            </CardBlock>
          </ComposeFocusable>
        )}
      </ComposeMount>
    </SocialProfileEnsure>
  )
}
